import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useChatbot } from '../../hooks/useChatbot.js';
import { ChatbotErrorCodes } from '@fabric/woody-client';
import { useAssistantStore } from '../../stores/assistantStore.js';
import { styled } from 'styled-components';
import { Link } from '@fabric-app/compat';

const Error = styled.div.withConfig({
  displayName: "ChatbotError__Error",
  componentId: "sc-890e1c13-0"
})([
  `padding:0.5rem;font-size:0.875rem;line-height:1.25rem;background-color:#fee2e2;color:#dc2626;border-radius:0.375rem;`
]);
const RetryButton = styled.button.withConfig({
  displayName: "ChatbotError__RetryButton",
  componentId: "sc-890e1c13-1"
})([
  `margin-left:0.5rem;text-decoration:underline;`
]);
const messages = {
  [ChatbotErrorCodes.INTERNAL_SERVER_ERROR]: "Something went wrong.",
  [ChatbotErrorCodes.USAGE_LIMIT_EXCEEDED]: "You’ve hit your plan’s answer limit"
};
const isRetryable = (error) => {
  return error !== ChatbotErrorCodes.USAGE_LIMIT_EXCEEDED;
};
const needsUpgrade = (error) => {
  return error === ChatbotErrorCodes.USAGE_LIMIT_EXCEEDED;
};
const ChatbotError = () => {
  const { error, retry } = useChatbot();
  const { setChatAssistantOpen } = useAssistantStore();
  if (!error || error === ChatbotErrorCodes.USAGE_LIMIT_EXCEEDED) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Error, {
    children: [
      messages[error] || "Something went wrong.",
      needsUpgrade(error) && /* @__PURE__ */ jsxs(Fragment, {
        children: [
          " – ",
          /* @__PURE__ */ jsx(Link, {
            style: {
              textDecoration: "underline"
            },
            href: "/pricing",
            target: "_self",
            // For a weird reason the link doesn't work while the chatbot is open
            // Forcing the chatbot to close fixes it.
            onClick: () => setChatAssistantOpen(false),
            children: "upgrade for more."
          })
        ]
      }),
      retry && isRetryable(error) && /* @__PURE__ */ jsx(RetryButton, {
        onClick: () => {
          retry();
        },
        children: "Retry"
      })
    ]
  });
};

export { ChatbotError as default };
//# sourceMappingURL=ChatbotError.js.map
